<ng-template #template>
    <div class="adicionar-complemento-modal">
        <div class="modal-header">
            <h4 class="modal-title">{{ 'support.cotacoes.modal.adicionar-complemento.titulo' | translate }} - ({{cotacao?.license_plate}}) {{cotacao?.vehicle}} - {{cotacao?.vehicle_year}}</h4>
            <button type="button" data-dismiss="modal" aria-label="Close" class="btn-close" (click)="fecharModal(false);"></button>
        </div>
        <form name="cotacaoForm" class="form-cotacao form-validate" [formGroup]="cotacaoForm" (ngSubmit)="salvar(0)">
            <div class="modal-body">
                <div class="panel-total-pecas">
                    <div class="panel-pecas row pecas-header vertical-align">
                        <div class="col-sm-2 col-md-2">
                            <div class="mb-3 form-group">
                                <input-component label="support.cotacoes.modal.adicionar-complemento.pecas.tabela.peca.label" [control]="partNameControl" />
                            </div>
                        </div>
                        <div class="col-sm-2 col-md-2">
                            <div class="mb-3 form-group">
                                <input-component label="support.cotacoes.modal.adicionar-complemento.pecas.tabela.codigo" [control]="partCodeControl" />
                            </div>
                        </div>
                        <div class="col-sm-1 col-md-1">
                            <div class="mb-3 form-group">
                                <input-component placeholder="1" type="number" [minValue]="1" [maxValue]="999" mask="999" label="support.cotacoes.modal.adicionar-complemento.pecas.tabela.quantidade.label" [control]="partQuantityControl" />
                            </div>
                        </div>
                        <div class="col-sm-4 col-md-4">
                            <select-component class="type-input" [options]="types" [isMultiselect]="true" label="buyer.create-quotation.quotation-parts.form.label.type" [control]="typeControl" />
                        </div>
                        <div class="col-sm-2 col-md-2">
                            <select-component class="condition-input" [options]="allowsUsedOptions" label="buyer.create-quotation.quotation-parts.form.label.condition" [control]="allowsUsedControl" />
                        </div>
                        <div class="col-sm-1 col-md-1">
                            <div class="mb-3 form-group">
                                <button type="button" class="btn btn-primary btn-sm btn-adicionar-pecas" (click)="adicionarPeca()"><i class="fa fa-plus"></i></button>
                            </div>
                        </div>
                    </div>
                    <fieldset class="mb0 pb0">
                        <div class="row">
                            <div class="col-sm-12 col-md-12">
                                <div class="table-responsive">
                                    <ng-scrollbar>
                                        @if (cotacaoComplementos?.pecas?.length > 0) {
                                            <table class="table tabela-novacot table-striped table-hover margtabela mb0">
                                                <thead>
                                                    <tr class="text-center">
                                                        <th class="thPartName"></th>
                                                        <th class="thPartCode"></th>
                                                        <th class="thQuantity"></th>
                                                        <th class="thType"></th>
                                                        <th class="thCondition"></th>
                                                        <th></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    @for (peca of cotacaoComplementos?.pecas; track peca; let i = $index) {
                                                        <tr [attr.data-index]="i">
                                                            <td><label ellipsis class="ellipsis6">{{peca.PartName}}</label></td>
                                                            <td><label ellipsis class="ellipsis3">{{peca.PartCode}}</label></td>
                                                            <td>{{peca.PartQuantity}}</td>
                                                            <td><label ellipsis class="ellipsis6">{{peca.TypeNames}}</label></td>
                                                            <td><label ellipsis class="ellipsis6">{{peca.Condition}}</label></td>
                                                            <td>
                                                                <button class="btn btn-sm btn-light excluirpeca" (click)="removerPeca(i)">
                                                                    <i class="fa fa-trash"></i>
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    }
                                                </tbody>
                                            </table>
                                        } @else {
                                            <div class="nenhuma-peca-adicionada">
                                                {{ 'support.cotacoes.modal.adicionar-complemento.pecas.tabela.vazia' | translate }}
                                            </div>
                                        }
                                    </ng-scrollbar>
                                </div>
                            </div>
                        </div>
                    </fieldset>
                </div>
            </div>
            <div class="modal-footer">
                <button id="salvar" type="submit" class="btn btn-primary" [disabled]="cotacaoComplementos.pecas.length == 0 || !alreadyLoadedERP ? 'disabled' : null">{{ 'elemento.generico-botao.adicionar' | translate}}</button>
                <button id="closeModal" type="button" class="btn btn-light" (click)="fecharModal(false);">{{ 'elemento.generico-botao.fechar' | translate}}</button>
            </div>
        </form>
        <ngx-loading [show]="loading" [template]="templateEdicao"></ngx-loading>
    </div>
</ng-template>
<ng-template #templateEdicao></ng-template>
